@if (length > pageSize) {
    <nav class="ap-paginator__container" [attr.aria-label]="ariaLabel ? ariaLabel : getRangeLabel()">
        <div class="ap-paginator__range-label" data-testid="range-label">
            {{ getRangeLabelRange() }}
            {{ 'paginator.range.of' | apContent }}
            <span aria-live="polite">
                {{ getRangeLabelTotal() }}
                {{ 'paginator.range.results' | apContent }}
            </span>
        </div>

        <ul class="ap-paginator__list">
            <li>
                <button
                    [style.visibility]="hideWhenOnPage(1)"
                    class="ap-paginator__page-link"
                    name="previousPage"
                    (click)="previousPage()"
                    [attr.aria-label]="'paginator.previous.page' | apContent | ariaLabel"
                    (keydown.ENTER)="previousPage()"
                    (keydown.SPACE)="previousPage()"
                    data-testid="previous-page"
                >
                    <
                </button>
            </li>
            @if (pageNotOnScreen(1)) {
                <li>
                    <button
                        class="ap-paginator__page-link number"
                        name="firstPage"
                        (click)="firstPage()"
                        [attr.aria-label]="'paginator.first.page' | apContent | ariaLabel"
                        (keydown.ENTER)="firstPage()"
                        (keydown.SPACE)="firstPage()"
                        data-testid="first-page"
                    >
                        1
                    </button>
                </li>

                @if (pageNotOnScreen(2) && getNumberOfPages() > 1) {
                    <li class="ap-paginator__dots">…</li>
                }
            }

            @for (number of pages; track number) {
                <li>
                    <button
                        class="ap-paginator__page-link number"
                        [ngClass]="{ 'ap-paginator__selected-page': number === currentPage }"
                        (click)="goToPage(number)"
                        (keydown.ENTER)="goToPage(number)"
                        (keydown.SPACE)="goToPage(number)"
                        [attr.aria-label]="number | ariaLabel"
                        [attr.aria-current]="number === currentPage ? 'page' : null"
                        [attr.data-testid]="number === currentPage ? 'current-page' : null"
                    >
                        {{ number }}
                    </button>
                </li>
            }

            @if (pageNotOnScreen(getLastPageNumber() - 1) && getNumberOfPages() > 1) {
                <li class="ap-paginator__dots">…</li>
            }
            @if (pageNotOnScreen(getLastPageNumber())) {
                <li>
                    <button
                        class="ap-paginator__page-link number"
                        name="lastPage"
                        (click)="lastPage()"
                        [attr.aria-label]="'paginator.last.page' | apContent | ariaLabel"
                        (keydown.ENTER)="lastPage()"
                        (keydown.SPACE)="lastPage()"
                        data-testid="last-page"
                    >
                        {{ getLastPageNumber() }}
                    </button>
                </li>
            }

            <li>
                <button
                    [style.visibility]="hideWhenOnPage(getLastPageNumber())"
                    class="ap-paginator__page-link"
                    name="nextPage"
                    (click)="nextPage()"
                    [attr.aria-label]="'paginator.next.page' | apContent | ariaLabel"
                    (keydown.ENTER)="nextPage()"
                    (keydown.SPACE)="nextPage()"
                    data-testid="next-page"
                >
                    >
                </button>
            </li>
        </ul>
    </nav>
}
